import type { CheckoutViewState } from "../types/checkout";

export function resolveSessionViewState(
  status?: string,
  timeRemaining = 0
): CheckoutViewState {
  if (timeRemaining <= 0) return "TIMEOUT";
  if (status === "PAID") return "SUCCESS";
  if (status === "FAILED") return "FAILED";
  if (status === "EXPIRED") return "TIMEOUT";
  return "SCAN";
}

export function resolveDirectViewState(
  status?: string,
  timeRemaining = 0
): CheckoutViewState {
  if (status === "PAID" || status === "SUCCESS") return "SUCCESS";
  if (status === "FAILED" || status === "FAILURE") return "FAILED";
  if (timeRemaining <= 0) return "TIMEOUT";
  if (status === "EXPIRED") return "TIMEOUT";
  return "SCAN";
}
